import type { RoleCode } from '@tracker/shared';

interface GreetingHeroProps {
  greeting: string;
  firstName: string;
  today: string;
  roles: RoleCode[];
}

export function GreetingHero({ greeting, firstName, today, roles }: GreetingHeroProps) {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-teal-600 to-teal-800 p-5 text-white shadow-lg sm:p-6">
      <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-white/10 blur-2xl" />
      <div className="absolute -bottom-4 left-1/3 h-24 w-24 rounded-full bg-teal-400/20 blur-xl" />
      <div className="absolute right-1/4 top-1/2 h-16 w-16 rounded-full bg-white/5 blur-lg" />

      <div className="relative z-10 space-y-1.5">
        <p className="text-sm font-medium text-teal-100">{today}</p>
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
          {greeting}, {firstName}
        </h1>
        <div className="flex flex-wrap gap-1.5 pt-0.5">
          {roles.length > 0 ? (
            roles.map((r) => (
              <span
                key={r}
                className="rounded-full bg-white/15 px-2.5 py-0.5 text-xs font-medium"
              >
                {r.replace(/_/g, ' ')}
              </span>
            ))
          ) : (
            <span className="text-xs text-teal-200">No roles assigned</span>
          )}
        </div>
      </div>
    </div>
  );
}
